export enum HashOnly {
	merchant1 = "fhkj123",
	merchant_default = "ql_platform_default",
	merchant_1 = "ql_platform_1",
	merchant_2 = "ql_platform_2",
	merchant_3 = "ql_platform_3",
	merchant_4 = "ql_platform_4",
	merchant_5 = "ql_platform_5",
	merchant_6 = "ql_platform_6",
	merchant_7 = "ql_platform_7",
}
